<app-nav-header></app-nav-header>
<div class="wrapper">
	<div class="main">
		<div id="newsPage">
			<div class="titleArea">
				<div class="titleBox">
					<a
						[routerLink]="'/newsCenter'"
						title="前往新聞中心">
						<i
							class="fa fa-arrow-left"
							aria-hidden="true"></i>
						&nbsp; 新聞中心
					</a>
				</div>
			</div>

			<!-- ----------------------------------------------------------------------- -->
			<!--                                  主圖-新聞                                -->
			<!-- ----------------------------------------------------------------------- -->

			<div
				class="imgArea"
				*ngIf="fullPiece?.TypeEN === 'news'">
				<img
					[src]="fullPiece?.Image"
					alt="" />
			</div>

			<!-- ----------------------------------------------------------------------- -->
			<!--                                   內文                                   -->
			<!-- ----------------------------------------------------------------------- -->

			<div
				class="bodyArea"
				*ngIf="fullPiece?.TypeEN === 'news'">
				<div class="bodyBox">
					<h1>{{ fullPiece?.Content }}</h1>

					<span>
						發佈時間：
						<time>{{ fullPiece?.Date }}</time>
					</span>

					<div [innerHTML]="fullPiece?.Body"></div>

					<div class="tagBox">
						<ng-container *ngFor="let tag of fullPiece?.Tags">
							<p>{{ tag }}</p>
						</ng-container>
					</div>
				</div>
			</div>

			<!-- ----------------------------------------------------------------------- -->
			<!--                                 時間-電子報                               -->
			<!-- ----------------------------------------------------------------------- -->

			<div
				class="eNewsDateArea"
				*ngIf="fullPiece?.TypeEN === 'electronic'">
				<div class="eNewsDateBox">
					<span>
						發佈時間：
						<time>{{ fullPiece?.Date }}</time>
					</span>
				</div>
			</div>

			<!-- ----------------------------------------------------------------------- -->
			<!--                                 圖片-電子報                               -->
			<!-- ----------------------------------------------------------------------- -->

			<div
				class="eNewsImgArea"
				*ngIf="fullPiece?.TypeEN === 'electronic'">
				<div class="eNewsImgBox">
					<div
						class="eNewsImgCtn"
						*ngFor="let src of fullPiece?.Image">
						<img
							[src]="src"
							alt="" />
					</div>
				</div>
			</div>

			<!-- ----------------------------------------------------------------------- -->
			<!--                                   品牌                                   -->
			<!-- ----------------------------------------------------------------------- -->

			<div class="brandArea">
				<div class="brandBox">
					<h2>坤侑科技</h2>
					<p>時刻創新，提供專業客製化解決方案</p>
				</div>
			</div>

			<!-- ----------------------------------------------------------------------- -->
			<!--                                  相關議題                                 -->
			<!-- ----------------------------------------------------------------------- -->

			<div class="topicArea">
				<div class="topicBox">
					<h2>關注更多相關議題</h2>

					<div
						class="swiperBox"
						*ngIf="showSwiper">
						<swiper
							[slidesPerView]="perPage"
							[spaceBetween]="24"
							[speed]="200"
							[scrollbar]="{
								el: '.swiper-scrollbar',
								hide: false
							}"
							[navigation]="{ nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' }"
							[observeParents]="true">
							<ng-container *ngFor="let topic of relatedPieces">
								<ng-template swiperSlide>
									<div
										class="info-card"
										(click)="goViewNews(topic?.TypeEN, topic?.FileTitle)">
										<div class="imgBox">
											<img
												[src]="topic?.Image"
												alt=""
												width="100%" />
										</div>

										<div class="vital">
											<p class="date">{{ topic?.Date }}</p>
											<p class="type">
												<span class="initial">{{ topic?.Type?.split(' ｜ ')[0] }}</span>
												｜
												{{ topic?.Type?.split(' ｜ ')[1] }}
											</p>
											<h3 class="content">
												{{ topic?.Content }}
											</h3>
										</div>
									</div>
								</ng-template>
							</ng-container>
						</swiper>
						<div
							class="swiper-btm"
							[ngStyle]="
								this.relatedPieces.length > this.perPage ? { display: 'flex' } : { display: 'none' }
							">
							<div class="scroll">
								<div class="swiper-scrollbar"></div>
							</div>
							<div class="action">
								<button
									class="swiper-button-prev"
									aria-label="前一頁"></button>
								{{ swiperPageRef }}
								<button
									class="swiper-button-next"
									aria-label="下一頁"></button>
							</div>
						</div>
					</div>
				</div>
			</div>

			<app-partnership></app-partnership>
		</div>
	</div>
</div>
<app-footer></app-footer>
